import {
  AreasOfFocus,
  fetchAreasOfFocus as apiFetchAreasOfFocus,
} from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle, no-restricted-imports
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type State = AreasOfFocus | null | undefined;

export type Action = {
  type: 'AREAS_OF_FOCUS_SET';
  areasOfFocus: AreasOfFocus | null | undefined;
};

// Reducer

export function areasOfFocusReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = null,
  action: Action
) {
  switch (action.type) {
    case 'AREAS_OF_FOCUS_SET': {
      return action.areasOfFocus;
    }

    default:
      return state;
  }
}

// Actions

export const fetchAreasOfFocus =
  () => (dispatch: Dispatch, getState: GetState) => {
    if (getState().areasOfFocus) {
      return;
    }

    apiFetchAreasOfFocus()
      .then((areasOfFocus) => {
        dispatch({
          type: 'AREAS_OF_FOCUS_SET',
          areasOfFocus,
        });
      })
      .catch(setError);
  };
